import{Item as SemanticItem}from"semantic-ui-react";export{ItemContent,ItemDescription,ItemExtra,ItemGroup,ItemHeader,ItemImage,ItemMeta}from"semantic-ui-react";export const Item=SemanticItem;export default Item;
//# sourceMappingURL=Item.js.map
